import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../contexts/hooks';
import { useApiOrders } from '../api/api.orders';
import { setFilteredOrders, setPanelVisible, setFilteresToOrders } from '../contexts/slices/orders';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para manejar la lógica de filtros automáticos
 * Ejecuta búsquedas automáticas cuando se modifican los filtros con Redirect: true
 */
export const useFilterAutoExecution = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { GetOrdersByFilter, findOrder } = useApiOrders();
  const currentFilters = useAppSelector((x) => x.globalOrders.FiltersToOrders);
  
  useEffect(() => {
    // Solo ejecutar si hay filtros con fechas válidas y flag de redirección
    if (currentFilters && 
        currentFilters.Fechas && 
        currentFilters.Fechas.length > 0 && 
        currentFilters.Redirect) {      
      GetOrdersByFilter(currentFilters)
        .then((res) => {
          if (res.length > 0) {
            dispatch(setFilteredOrders(res));
            
            // Solo ejecutar findOrder si estamos en la página de órdenes
            if (location.pathname === '/admin-orders') {
              findOrder(undefined, res[0].Ord_Id);
              dispatch(setPanelVisible(true));
              
              // Limpiar el flag de redirección después de ejecutar
              dispatch(setFilteresToOrders({
                ...currentFilters,
                Redirect: false
              }));
            }
          }
        })
        .catch((error) => {
          console.error('Error al obtener órdenes filtradas:', error);
        });
    }
  }, [currentFilters, location.pathname, GetOrdersByFilter, findOrder, dispatch]);
};

export default useFilterAutoExecution;
